import { Stack, Typography } from "@mui/material";
import ShowLabelItem from "./ShowLabelItem.tsx";
import Title from "./Title.tsx";
import type { ChartStyleSettings, ValueAxis } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  settings: ChartStyleSettings;
  axis: ValueAxis;
  readonlyMode: boolean;
}

export default function ValueAxisItem({ settings, axis, readonlyMode }: Props) {
  return (
    <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
      <Typography variant="subtitle2">{axis.name}</Typography>
      <ShowLabelItem settings={settings} axis={axis} readonlyMode={readonlyMode} />
      <Title settings={settings} axis={axis} readonlyMode={readonlyMode} />
    </Stack>
  );
}
